import { Link } from "react-router-dom"
import { useLanguage } from "../hooks/useLanguage"
import { LogoLockup } from "./Logo"

const colTitle = "font-mono text-[12px] font-normal text-gms-subtle"
// Em telas de toque os links ganham 44px de altura; com mouse seguem o espaçamento do design
const colLink = "gms-nav-link inline-flex items-center [@media(pointer:coarse)]:min-h-[44px]"
const col = "flex flex-col gap-[10px] text-[15px] font-medium [@media(pointer:coarse)]:gap-0"

export default function Footer() {
  const { t, language } = useLanguage()
  const info = t.contactInfo

  const pageLinks = [
    { label: t.nav.services, href: "#servicos" },
    { label: t.nav.process, href: "#processo" },
    { label: t.nav.about, href: "#sobre" },
    { label: t.nav.faq, href: "#faq" },
    { label: t.nav.blog, href: "/blog" },
  ]
  const contactLinks = [
    { label: t.contact.channels.whatsapp, href: info.whatsappUrl },
    { label: t.contact.channels.telegram, href: info.telegramUrl },
    { label: info.email, href: `mailto:${info.email}` },
  ]

  return (
    <footer className="gms-wrap pb-10 pt-14">
      <div className="flex flex-wrap items-start justify-between gap-x-12 gap-y-7 border-b border-gms-line pb-8">
        <div className="max-w-[360px]">
          <Link
            to={language === "en" ? "/en" : "/"}
            onClick={() => window.scrollTo({ top: 0 })}
            aria-label="GMS Tech"
            className="inline-flex min-h-[44px] items-center gap-[10px] text-gms-ink no-underline"
          >
            <LogoLockup size={30} textSize={20} />
          </Link>
          <p className="mt-[10px] text-[15px] leading-[1.55] text-gms-muted">{t.footer.tagline}</p>
        </div>

        <div className="flex flex-wrap gap-x-16 gap-y-8">
          <nav aria-label={t.footer.navLabel} className={col}>
            <span className={colTitle}>{t.footer.pageCol}</span>
            {pageLinks.map(({ label, href }) => (
              <a key={href} href={href} className={colLink}>
                {label}
              </a>
            ))}
          </nav>
          <div className={col}>
            <span className={colTitle}>{t.footer.contactCol}</span>
            {contactLinks.map(({ label, href }) => (
              <a
                key={href}
                href={href}
                target={href.startsWith("http") ? "_blank" : undefined}
                rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
                className={colLink}
              >
                {label}
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-6 flex flex-wrap justify-between gap-x-6 gap-y-2 font-mono text-[12.5px] text-gms-subtle">
        <span>
          © {new Date().getFullYear()} GMS Tech · CNPJ {info.cnpj}
        </span>
        <span>{t.footer.madeIn}</span>
      </div>
    </footer>
  )
}
